import VueScrollTo from 'vue-scrollto'

export default ({ app, router, Vue }) => {
  Vue.use(VueScrollTo)
}
